<template>
  <div>
    <ContentSectionLoader v-if="!loaded" />
    <Transition name="fade">
      <div v-if="loaded">
        <div
          v-if="loaded && discussions.length"
          class="flex items-center justify-between content-center px-2 mt-4"
        >
          <h2 class="flex-1 m-0">
            {{ title }}
            <span
              v-if="loaded"
              v-text="`(${count})`"
            />
          </h2>
        </div>
        <div class="pl-2">
          <div
            v-if="loaded && discussions.length"
            class="table-responsive"
          >
            <table
              class="table table-files min-w-table"
              style="min-height: auto;"
            >
              <thead>
                <tr>
                  <th v-text="'Category'" />
                  <th v-text="'# of Replies'" />
                  <th v-text="'Archived'" />
                  <th />
                </tr>
              </thead>
              <tbody>
                <tr v-if="!count">
                  <td colspan="3">
                    <span
                      class="block text-center pr-6"
                      v-text="'No discussions have been archived.'"
                    />
                  </td>
                </tr>
                <tr
                  v-for="post in discussions"
                  :key="post.uuid"
                >
                  <td v-text="post.attributes.title" />
                  <td>
                    <a
                      class="btn btn--sm"
                      :href="post.category._links.frontend.self"
                      v-text="post.category.attributes.title"
                    />
                  </td>
                  <td v-text="post.meta.reply_count" />
                  <td>
                    {{ post.deleted_at | calendarTime }}
                  </td>
                  <td>
                    <a
                      href="#"
                      class="btn btn--border btn--sm"
                      @click.prevent="restorePost(post.uuid)"
                      v-text="'Restore'"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <article
          v-if="!loaded"
          class="card flex flex-row load text-center p-4"
          v-text="'Loading Archived Discussions...'"
        />
        <div
          v-if="loaded && !discussions.length"
          class="empty mb-4"
        >
          <section>
            <h2 v-text="'There are no archived discussion posts.'" />
            <p>Archiving discussions removes it and any replies it contains from being visible.</p>
          </section>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script type="text/babel">
import { mapActions, mapState } from 'vuex'

export default {
  name: 'DiscussionPostsArchive',
  props: {
    title: {
      type: String,
      required: false,
      default: 'Archived Discussions',
    },
    perPage: {
      type: Number,
      required: false,
      default: 20,
    },
  },
  data() {
    return {
      loaded: false,
    }
  },
  computed: {
    ...mapState({
      count: state => state.discussion.archivedPosts.data.length,
      totalCount: state => _.get(state.discussion.archivedPosts, 'meta.pagination.total', 0),
      discussions: state => state.discussion.archivedPosts.data,
    }),
    params() {
      return {
        archived: true,
        include: 'category',
        per_page: this.perPage,
      }
    },
  },
  mounted() {
    this.discussionGetArchivedPosts({
      params: this.params,
      force: true,
    }).then(() => {
      this.loaded = true
    })
  },
  methods: {
    ...mapActions([
      'discussionGetArchivedPosts',
      'discussionRestorePost',
    ]),
    restorePost(uuid){
      this.loaded = false

      const vm = this

      this.discussionRestorePost(uuid).then(()=>{
        this.discussionGetArchivedPosts({ force: true }).then(()=>{
          vm.loaded = true
        })
      })
    },
  },
}
</script>
